<script lang="ts">
    import Header from "./header.svelte";
    import Footer from "./footer.svelte";
    import Modal from "svelte-simple-modal";

    var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date(); (function(){ var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0]; s1.async=true; s1.src='https://embed.tawk.to/5f4c65d3f0e7167d000c117c/default'; s1.charset='UTF-8'; s1.setAttribute('crossorigin','*'); s0.parentNode.insertBefore(s1,s0); })(); 
</script>
<Header />
<slot />
<Modal>
    <Footer />
</Modal>